import _camelCase  from 'lodash/camelCase';
import { ucfirst } from 'tools/jsTools';

export default (urn: Urn) => {
	const [, service, importName] = urn.split(':');
	import(`../modelx/models/private/${service}/${ucfirst(_camelCase(importName))}Model.ts`).catch(() => null);
};